import Icon from '../components/Icon.vue'

Icon.register({
  handshake: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M434.7 64H348.8C340.8 64 333.1 67 327.2 72.4L228.9 162.4C228.8 162.5 228.7 162.7 228.6 162.8 212 178.4 212.3 203.3 226.5 218.8 239.2 232.7 265.9 236.4 282.6 221.5 282.7 221.4 282.9 221.4 283 221.3L362.9 148.1C369.4 142.2 379.6 142.6 385.5 149.1 391.5 155.6 391 165.7 384.5 171.7L358.4 195.6 504 313.8C506.9 316.2 509.5 318.8 511.9 321.5V128L457.3 73.4C451.4 67.4 443.2 64 434.7 64zM544 128.2V352.1C544 369.8 558.3 384.1 576 384.1H640V128.2H544zM592 352.1C583.2 352.1 576 344.9 576 336.1S583.2 320.1 592 320.1 608 327.3 608 336.1 600.8 352.1 592 352.1zM0 384H64C81.7 384 96 369.7 96 352V128.2H0V384zM48 320.1C56.8 320.1 64 327.3 64 336.1S56.8 352.1 48 352.1 32 344.9 32 336.1C32 327.2 39.2 320.1 48 320.1zM483.9 338.7L334.6 217.5 304.6 245C274.9 272.1 229.4 269.5 202.9 240.6 176 211.2 178.1 165.7 207.3 138.9L289.1 64H205.3C196.8 64 188.7 67.4 182.7 73.4L128 128V351.9H146.3L236.8 433.8C264.2 456.1 304.5 451.9 326.8 424.5L327 424.3 344.9 439.8C360.8 452.8 384.3 450.3 397.2 434.4L428.6 395.8 434 400.2C447.7 411.3 467.9 409.3 479 395.5L488.5 383.8C499.7 370 497.6 349.9 483.9 338.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/handshake.js
// module id = SyKk
// module chunks = 144